var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineChartUp01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-chart-up-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21 21.5H4.6C4.03995 21.5 3.75992 21.5 3.54601 21.391C3.35785 21.2951 3.20487 21.1422 3.10899 20.954C3 20.7401 3 20.4601 3 19.9V3.5M20 8.5L16.0811 12.6827C15.9326 12.8412 15.8584 12.9204 15.7688 12.9614C15.6897 12.9976 15.6026 13.0125 15.516 13.0047C15.4179 12.9958 15.3215 12.9458 15.1287 12.8457L11.8713 11.1543C11.6785 11.0542 11.5821 11.0042 11.484 10.9953C11.3974 10.9875 11.3103 11.0024 11.2312 11.0386C11.1416 11.0796 11.0674 11.1588 10.9189 11.3173L7 15.5",
    stroke: "#4F9CF9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartUp01);
export default __webpack_public_path__ + "static/media/line-chart-up-01.fc297c6708ecb849cf4c32c72ffa01af.svg";
export { ForwardRef as ReactComponent };